import React, {useContext} from 'react';
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../../pages/ProductStencil";

interface AddToCartControlsProps {
    quantity: number;
    setQuantity: React.Dispatch<React.SetStateAction<number>>;
}

export const AddToCartControls: React.FC<AddToCartControlsProps> = ({quantity, setQuantity} ) => {
    const translate = useI18N();

    const {Packaging, activeProductIndex, stencil} = useContext(ProductContext);
    const {MinimumOrderableQuantity: minQuantity, StockType} = Packaging[activeProductIndex];
    const {maximumAddToCartQuantity} = stencil;

    if (StockType === "BLOCKSALE") {
        return null;
    }
    const handleIncrement = () => {
        if (quantity < maximumAddToCartQuantity) {
            setQuantity(quantity + 1);
        }
    };

    const handleDecrement = () => {
        if (quantity > minQuantity) {
            setQuantity(quantity - 1);
        }
    };

    const handleChange = (e) => {
        setQuantity(e.target.value);
    };

    const handleBlur = () => {
        const minimum = minQuantity > 0 ? minQuantity : 1;
        setQuantity((prev) => Math.max(minimum, Math.min(maximumAddToCartQuantity, Number(prev))));
    };

    return (
        <div className="add-to-cart__controls">
            <button className={"add-to-cart__controls--decrement"}
                    aria-label={translate("Decrement quantity")} onClick={handleDecrement}
                    disabled={minQuantity > 0 ? quantity <= minQuantity : quantity <= 1}></button>
            <input type="number" value={quantity} aria-label={translate("Quantity input")} onChange={handleChange}
                   onBlur={handleBlur} min={minQuantity}
                   max={maximumAddToCartQuantity}/>
            <button className={"add-to-cart__controls--increment"} onClick={handleIncrement}
                    aria-label={translate("Increment quantity")}
                    disabled={quantity >= maximumAddToCartQuantity}></button>
        </div>
    )
}
